// import React, { useState } from "react";
// import { Button, CircularProgress, Backdrop } from "@mui/material";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// import { logger } from "../../../utils/logger";
// import {getSystemFormattedTimestamp} from "../../../utils/dateFormatted";


// const DownloadButton = ({ data, type, username, role }) => {
//   const [loading, setLoading] = useState(false);
//   const BaseUrl = process.env.REACT_APP_BASE_URL;

//   const handleDownload = async (groupType) => {
//     setLoading(true);
//     try {
//       const endpoint =
//         groupType === "small" ? "download-small-group" : "download-large-group";
//       const response = await fetch(`${BaseUrl}api/label/${endpoint}`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ data }),
//       });

//       if (!response.ok) {
//         let errorMsg = "Failed to generate PDF";
//         try {
//           const errorData = await response.json();
//           errorMsg = errorData.message || errorMsg;
//         } catch {}
//         throw new Error(errorMsg);
//       }

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = url;
//       link.download = `${groupType}-group-${getSystemFormattedTimestamp()}.pdf`;
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(url);
//       logger.info("PDF downloaded successfully", {
//         groupType,
//         filterType: type,
//         username,
//         role,
//         totalRecords: data?.length || 0,
//       });
//     } catch (err) {
//       logger.error("Error downloading PDF", {
//         groupType,
//         filterType: type,
//         username,
//         role,
//         error: err.message,
//       });
//       alert(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Button
//         variant="contained"
//         color="primary"
//         onClick={() => handleDownload("small")}
//         style={{ marginRight: 10 }}
//       >
//         <PictureAsPdfIcon style={{ marginRight: 8 }} />
//         Download Small Group
//       </Button>
//       <Button
//         variant="contained"
//         color="secondary"
//         onClick={() => handleDownload("large")}
//       >
//         <PictureAsPdfIcon style={{ marginRight: 8 }} />
//         Download Large Group
//       </Button>
//       <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
//         <CircularProgress color="inherit" />
//         <span style={{ marginLeft: 10 }}>Generating PDF, please wait...</span>
//       </Backdrop>
//     </>
//   );
// };

// export default DownloadButton;

// import React, { useState } from "react";
// import { Button, CircularProgress, Backdrop } from "@mui/material";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// import { logger } from "../../../utils/logger";
// import { getSystemFormattedTimestamp } from "../../../utils/dateFormatted";

// const DownloadButton = ({ data, type, username, role }) => {
//   const [loading, setLoading] = useState(false);
//   const BaseUrl = process.env.REACT_APP_BASE_URL;

//   const handleDownload = async () => {
//     setLoading(true);

//     try {
//       const response = await fetch(`${BaseUrl}api/label/generate-labels`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ data }),
//       });

//       if (!response.ok) {
//         let errorMsg = "Failed to generate PDF";
//         try {
//           const errorData = await response.json();
//           errorMsg = errorData.message || errorMsg;
//         } catch {}
//         throw new Error(errorMsg);
//       }

//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);

//       const link = document.createElement("a");
//       link.href = url;
//       // link.download = `address-labels-${getSystemFormattedTimestamp()}.pdf`;
//       const fileStatus = type ? type.replace(/\s+/g, "-") : "labels";

//       link.download = `${fileStatus}-${getSystemFormattedTimestamp()}.pdf`;

//       document.body.appendChild(link);
//       link.click();
//       link.remove();

//       window.URL.revokeObjectURL(url);

//       logger.info("PDF downloaded successfully", {
//         filterType: type,
//         username,
//         role,
//         totalRecords: data?.length || 0,
//       });
//     } catch (err) {
//       logger.error("Error downloading PDF", {
//         filterType: type,
//         username,
//         role,
//         error: err.message,
//       });

//       alert(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <>
//       <Button
//         variant="contained"
//         color="primary"
//         onClick={handleDownload}
//       >
//         <PictureAsPdfIcon style={{ marginRight: 8 }} />
//         Download PDF
//       </Button>

//       <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
//         <CircularProgress color="inherit" />
//         <span style={{ marginLeft: 10 }}>Generating PDF, please wait...</span>
//       </Backdrop>
//     </>
//   );
// };

// export default DownloadButton;


import React, { useState } from "react";
import { Button, CircularProgress, Backdrop } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { logger } from "../../../utils/logger";
import { getSystemFormattedTimestamp } from "../../../utils/dateFormatted";
import ExportFormatModal from "../../../components/ExportFormatModal";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const DownloadButton = ({ data, type, username, role }) => {
  const [loading, setLoading] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const BaseUrl = process.env.REACT_APP_BASE_URL;

  const handleDownload = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${BaseUrl}api/label/generate-labels`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ data }),
      });

      if (!response.ok) {
        let errorMsg = "Failed to generate PDF";
        try {
          const errorData = await response.json();
          errorMsg = errorData.message || errorMsg;
        } catch {}
        throw new Error(errorMsg);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const fileStatus = type ? type.replace(/\s+/g, "-") : "labels";
      link.download = `${fileStatus}-${getSystemFormattedTimestamp()}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      logger.info("PDF downloaded successfully", {
        filterType: type,
        username,
        role,
        totalRecords: data?.length || 0,
      });
    } catch (err) {
      logger.error("Error downloading PDF", {
        filterType: type,
        username,
        role,
        error: err.message,
      });
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleExcelDownload = () => {
    if (!data || data.length === 0) return;
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Labels");
    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([buf], { type: "application/octet-stream" }),
      `address-labels-${getSystemFormattedTimestamp()}.xlsx`
    );
  };

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={() => setExportModalOpen(true)}
      >
        <PictureAsPdfIcon style={{ marginRight: 8 }} />
        Download
      </Button>

      <ExportFormatModal
        open={exportModalOpen}
        onClose={() => setExportModalOpen(false)}
        onSelectPDF={handleDownload}
        onSelectExcel={handleExcelDownload}
      />

      <Backdrop open={loading} style={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
        <span style={{ marginLeft: 10 }}>Generating PDF, please wait...</span>
      </Backdrop>
    </>
  );
};

export default DownloadButton;